import { render, staticRenderFns } from "./CancelledAppointmentList.vue?vue&type=template&id=7db6ece0"
import script from "./CancelledAppointmentList.vue?vue&type=script&lang=js"
export * from "./CancelledAppointmentList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports